import { useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

// fixed shaking issue when scrollbar show and hide
const useObserverRoot = () => {
    useEffect(() => {
        // storage last changed entity
        let rootEntity;
        let scrollEntity;
        const myObserver = new ResizeObserver(entities => {
            const [first, second] = entities;

            rootEntity = first ?? rootEntity;

            scrollEntity = second ?? scrollEntity;

            // if reach the critical point that scroll, give a more space
            if (rootEntity && scrollEntity && scrollEntity?.contentRect?.height > rootEntity?.contentRect?.height) {
                const scrollEle = document.querySelector('#root .ant-layout');
                const existingCriticalSpace = document.querySelector('#criticalSpace');
                if (!existingCriticalSpace) {
                    const criticalSpaceEle = document.createElement('div');
                    criticalSpaceEle.setAttribute('id', 'criticalSpace');
                    criticalSpaceEle.setAttribute(
                        'style',
                        `height: 10px;background-color: ${
                            scrollEle ? getComputedStyle(scrollEle).getPropertyValue('background-color') : 'transparent'
                        }`
                    );
                    document.querySelector('#root').appendChild(criticalSpaceEle);
                }
            } else {
                const criticalSpaceEle = document.querySelector('#criticalSpace');
                if (criticalSpaceEle) {
                    document.querySelector('#root').removeChild(criticalSpaceEle);
                }
            }
        });
        // watch root div
        myObserver.observe(document.querySelector('#root'));

        // watch scroll div
        const setScrollObserver = () => {
            const scrollEle = document.querySelector('#root .ant-layout');
            if (scrollEle) {
                myObserver.observe(scrollEle);
            } else {
                setTimeout(setScrollObserver, 1000);
            }

            return true;
        };

        setScrollObserver();

        return () => {
            myObserver.disconnect();
        };
    }, []);
};

export default useObserverRoot;
